import MapPinIcon from "./MapPinIcon";
export default MapPinIcon;
